import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Switch, Route } from 'react-router-dom';

import NationalId from './nationa_id/nationa_id';
import SejamRedirect from './sejamRedirect/sejamRedirect';
import SejamSuccess from './page/sejam/sejam';
import Otp from './otp/otp';
import Contarct from './contarct/index';
import ChangeOms from './page/changeOms/changeOms';
import OmsSuccess from './page/changeOms/succesOms/successOms'

let useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: "linear-gradient(rgba(243, 245, 249, 0.5),rgba(243, 245, 249, 0.5)), url('/assets/images/register/line.png') no-repeat center center",
        backgroundSize: "100% 600px",
        "@media(max-width : 600px)": {
            backgroundSize: "contain",
        },

    },

}))


const Index = () => {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <Switch>
                <Route exact path="/register/national">
                    <NationalId />
                </Route> 
                <Route exact path="/register/sejam">
                    <SejamRedirect />
                </Route> 
                <Route exact path="/register/sejam/success">
                    <SejamSuccess />
                </Route> 
                <Route exact path="/register/otp">
                    <Otp />
                </Route> 
                <Route exact path="/register/contarct">
                    <Contarct />
                </Route> 
                <Route exact path="/register/changeOms">
                    <ChangeOms />
                </Route> 
                <Route exact path="/register/changeOms/success">
                    <OmsSuccess />
                </Route> 
            </Switch>
        </div>
    )
}

export default Index                          